export enum ChipStyleStatusEnum {
    green = 253,
    blue = 251,
    orange = 252,
    red = 254
}

export enum LanguageAppEnum {
    Latin = 1,
    Ciril = 2
}

export enum LanguageAppEnumText {
    Latin = 'sr-Latin-RS',
    Ciril = 'sr-Cyrl-RS',
}

export enum StatusVerzijePojmaEnum {
    UPripremi = 7101,
    Aktivna = 7102,
    Neaktivna = 7103
}

export enum StatusPojmaEnum {
    UPripremi = 5101,
    CekaAktiviranje = 5102,
    UpisanURecnik = 5103,
    Deaktiviran = 5104
}

export enum StatusSvojstvaEnum {
    Neaktivno = 6101,
    Obrisano = 6102,
    Aktivno = 6103,
    Deaktivirano = 6104
}

export enum StatusPorukeEnum {
    U_PRIPREMI = 8101,
    CEKA_AKTIVIRANJE = 8102,
    OBJAVLJENA = 8103,
    DEAKTIVIRANA = 8104
}

export enum StatusElementaPorukeEnum {
    Neaktivno = 4101,
    Obrisano = 4102,
    Aktivno = 4103,
    Deaktivirano = 4104
}

export enum StatusSluzbeneEvidencijeEnum {
    UPripremi = 45101,
    CekaAktiviranje = 45102,
    UpisanUMetaregistar = 45103,
    Deaktiviran = 45104,
    CekaDeaktiviranje = 45105
}

export enum StatusStavkeSifarnikaEnum {
    Aktivna = 49101,
    Neaktivna = 49102
}

export enum VrstaTipaEnum {
    Tip = 0,
    Pojam = 1
}

export enum TipOgranicenjaEnum {
    Duzina = 1,
    RegularniIzraz = 2,
    MinimalnaDuzina = 3,
    MaksimalnaDuzina = 4,
    Enumerator = 5,
    BrojCifara = 6,
    MinimalnaVrednostUkljucujuciI = 7,
    MaksimalnaVrednostUkljucujuciI = 8,
    MinimalnaVrednostNeUkljucujuciI = 9,
    MaksimalnaVrednostNeUkljucujuciI = 10,
    BrojDecimala = 10,
    ValidacionoPravilo = 12
}

export enum OgranicenSifarnikomEnum {
    NijeOgraniceSifarnikomEnum = 0,
    OgraniceSifarnikomEnum = 1
}

export enum TipAgregacijeEnum {
    SvaSvojstva = 1,
    JednoOdSvojstava = 2,
    GrupaSvojstva = 3
}